<ul class="mr-auto"
[class.navbar-nav]="this.level === 0"
[class.nav-menu]="this.level === 0"
[class.dropdown-menu]="this.level !== 0"
#dropDownMenuRef>
  <ng-content select="[menu-head]"></ng-content>
  <ng-container *ngIf="menu && isBrowser">
    <li *ngFor="let item of menu; let i = index"
      routerLinkActive="active"
      [class.dropdown]="item.menus?.length"
      [class.dropdown-submenu]="item.menus?.length && level != limit - 1 && level != 0"
      class="nav-item mb" #muneList>
      <div *ngIf="item.menus?.length && level != limit - 1; then dropdown; else normal"></div>

      <ng-template #normal>
        <ng-container *ngIf="item.module == 'LINKING'">
          <a class="nav-link" href="{{ item?.otherSetting.url }}" target="_blank" title="{{ item.title }}{{'openNewWindow' | translate}}">{{ item.title }}</a>
        </ng-container>
        <ng-container *ngIf="item.module != 'LINKING'">
          <a class="nav-link" routerLink="./{{ item.path | appPath }}">{{ item.title }}</a>
        </ng-container>
      </ng-template>

      <ng-template #dropdown>
        <ng-container *ngIf="isIOS">
          <a class="nav-link dropdown-toggle" href="#" data-toggle="dropdown" role="button" aria-expanded="false"
          (click)="mobileFun($event,level,dropdown); toggleSubMenu($event, level)"
          >{{ item.title }}</a>
          <app-menu
          [menu]="item.menus"
          [level]="level + 1"
          [limit]="limit"
          #subMenu></app-menu>
        </ng-container>

        <ng-container *ngIf="!isIOS">
          <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false"
          (click)="mobileFun($event,level,dropdown); toggleSubMenu($event, level)"
          tmCloseOnContainerBlur [listenOnOpen]="item.listenOnOpen" [listenOnClose]="item.listenOnClose" [closeContainer]="closeDpMenu" #ccb="tmCCB"
          [attr.data-level]="level" [attr.data-index]="i">{{ item.title }}</a>
          <app-menu
          [menu]="item.menus"
          [level]="level + 1"
          [limit]="limit"
          (viewInit)="onSubMenuInit(subMenu, ccb)"
          #subMenu></app-menu>
        </ng-container>
      </ng-template>
    </li>
  </ng-container>
  <ng-content select="[menu-end]"></ng-content>
</ul>




